import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/"); return; }
    const sessionId = match[1];

    (async () => {
      try {
        await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#0B0B0B] text-[#F7F3EC] flex items-center justify-center">
      <p className="eyebrow">Signing you in…</p>
    </div>
  );
}
